import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Topbar from '../../components/Topbar';
import IndividualMenu from '../../components/IndividualMenu';
import SearchContext from '../../Api/Context/searchContext';
const Index = () => {
  const { keyword } = useParams();
  const {
    getSuperSubCategoriesSearch,
    searchResults,
    searching,
    searchSuccess,
    searchKeyWords,
  } = useContext(SearchContext);
  useEffect(() => {
    getSuperSubCategoriesSearch(keyword);
  }, [keyword]);
  return (
    <>
      <Topbar searchShow={true} />

      <section className='resultsPage'>
        <h6>Search Results ({searchSuccess && searchResults.length})</h6>
        {searching && <p>Searching.... </p>}
        {searchSuccess && searchResults.length < 1 ? (
          <p>No Items Found</p>
        ) : (
          searchResults &&
          searchResults.map((result) => <IndividualMenu item={result} />)
        )}
      </section>
    </>
  );
};

export default Index;
